<template>
  <div class="slider">
    <range-slider ref="slider" :min="0" :max="max" :step="step" :value="value" @input="handleInput">
      <template #knob>
        <span class="slider__value">
          {{ actualValue }}
          <Icon name="/base/robux.svg" />
        </span>
      </template>
    </range-slider>
  </div>
</template>

<script>
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'
import Icon from '@/components/Base/Icon/Icon.vue'

export default {
  name: 'RangeInput',
  props: {
    value: {
      type: Number,
      default: 20
    },
    min: {
      type: Number,
      default: 20
    },
    max: {
      type: Number,
      default: 5000
    },
    step: {
      type: Number,
      default: 50
    }
  },

  components: {
    Icon,
    RangeSlider
  },
  computed: {
    actualValue() {
      return this.value > this.max ? `>${this.max}` : this.value < this.min ? `<${this.min}` : this.value
    }
  },
  methods: {
    handleInput(value) {
      if (value === this.step + this.min) {
        value = this.step
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
@import './range-input';
</style>
